import { render, staticRenderFns } from "./DialogAddOwners.vue?vue&type=template&id=0f4f4445"
import script from "./DialogAddOwners.vue?vue&type=script&lang=js"
export * from "./DialogAddOwners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports